import TagManager from "react-gtm-module";

const GTM_ID: string = process.env.NEXT_PUBLIC_GTM_ID || "";

export const initGTM = () => {
  if (GTM_ID) {
    TagManager.initialize({ gtmId: GTM_ID });
  }
};

export const pushToDataLayer = (eventData: Record<string, unknown>) => {
  if (typeof GTM_ID !== "undefined") {
    TagManager.dataLayer({
      dataLayer: eventData,
    });
  }
};
